(function (root, factory) {
  var api = factory();
  if (root) root.AgoSeasonalPlacementV1 = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
}(typeof window !== 'undefined' ? window : null, function () {
  var CONTRACT_VERSION = 'seasonal-placement-v1';
  var MODES = { dynamic_lock: true, fixed_lock: true, random: true };

  function token(value) {
    return String(value || '').trim().toLowerCase().replace(/[\s_]+/g, '_');
  }

  function enabled(value) {
    return value === true || token(value) === 'true';
  }

  function position(value) {
    var parsed = parseInt(value, 10);
    return parsed > 0 && parsed <= 50 ? parsed : null;
  }

  function epoch(value) {
    var parsed = Date.parse(String(value || '').trim());
    return Number.isFinite(parsed) ? parsed : null;
  }

  function modeFor(schedule, surface, nowEpoch) {
    var fallback = { valid: false, mode: null, reason: 'missing' };
    if (!schedule || token(schedule.contractVersion || schedule.contract_version) !== CONTRACT_VERSION) return fallback;
    if (!enabled(schedule.enabled)) return { valid: false, mode: null, reason: 'disabled' };

    var beforeMode = token(schedule.beforeMode || schedule.before_mode);
    var activeMode = token(schedule.activeMode || schedule.active_mode);
    var afterMode = token(schedule.afterMode || schedule.after_mode);
    if (!MODES[beforeMode] || !MODES[activeMode] || !MODES[afterMode]) return { valid: false, mode: null, reason: 'mode' };

    var startAt = epoch(schedule.startAt || schedule.start_at);
    var endAt = epoch(schedule.endAt || schedule.end_at);
    if (startAt === null || endAt === null || endAt <= startAt) return { valid: false, mode: null, reason: 'date' };

    var prefix = token(surface) === 'web' ? 'web' : 'app';
    var fixedPosition = position(schedule[prefix + 'FixedPosition'] || schedule[prefix + '_fixed_position']);
    var positionStart = position(schedule[prefix + 'PositionStart'] || schedule[prefix + '_position_start']);
    var positionEnd = position(schedule[prefix + 'PositionEnd'] || schedule[prefix + '_position_end']);
    if (!positionStart || !positionEnd || positionEnd < positionStart) return { valid: false, mode: null, reason: 'position' };

    var now = Number(nowEpoch);
    if (!Number.isFinite(now)) now = Date.now();
    var mode = now < startAt ? beforeMode : (now < endAt ? activeMode : afterMode);
    if (mode === 'fixed_lock' && !fixedPosition) return { valid: false, mode: null, reason: 'fixed-position' };

    return {
      valid: true,
      mode: mode,
      fixedPosition: fixedPosition,
      positionStart: positionStart,
      positionEnd: positionEnd,
      priority: Number(schedule.selectionPriority || schedule.selection_priority || 0) || 0,
      startAt: startAt,
      endAt: endAt
    };
  }

  function shuffle(items) {
    var copy = items.slice();
    for (var index = copy.length - 1; index > 0; index -= 1) {
      var target = Math.floor(Math.random() * (index + 1));
      var item = copy[index];
      copy[index] = copy[target];
      copy[target] = item;
    }
    return copy;
  }

  return { CONTRACT_VERSION: CONTRACT_VERSION, modeFor: modeFor, shuffle: shuffle, token: token };
}));
